<template>
  <div class="intercom-scene">
    <div class="header">
      <div class="title">方案场景描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in sceneList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import intercomscene1 from "../../../../assets/programme/intercomscene1.png";
import intercomscene2 from "../../../../assets/programme/intercomscene2.png";
import intercomscene3 from "../../../../assets/programme/intercomscene3.png";
import intercomscene4 from "../../../../assets/programme/intercomscene4.png";

export default {
  setup() {
    return reactive({
      sceneList: [
        {
          id: 1,
          title: "一键开启可视对讲",
          text: "业主可一键开启视频对讲，遇到问题随时联系物业解决，降低安全隐患",
          logo: intercomscene1,
        },
        {
          id: 2,
          title: "访客到访 可远程开门",
          text: "主人通过对讲设备与来访者进行双向可视通话，通过来访者的声音或图像确认来访者的身份",
          logo: intercomscene2,
        },
        {
          id: 3,
          title: "物业一键监管",
          text: "物业可线上远程监管数据，发现问题立即联系业主，降低人员线下作业成本，提高社区管理效率",
          logo: intercomscene3,
        },
        {
          id: 4,
          title: "广告投放  增加流量",
          text: "可通过可视对讲智能屏投放广告，增加社区流量，促进商业化进程",
          logo: intercomscene4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.intercom-scene {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  width: 570px;
  margin-bottom: 16px;
  text-align: center;
  border: 1px solid #D5E3FA;
  overflow: hidden;
}
.body .list .item img {
  width: 100%;
}
.body .list .item .title {
    font-size: 14px;
    color: #248EFB;
    margin-top: 16px;
    font-weight: 600;
}
.body .list .item .text {
    width: 311px;
    font-size: 12px;
    color: #495A6C;
    margin: 8px auto 16px;
}
</style>
